import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { TERMS_AND_CONDITIONS_VERSION } from "shared/constants";
import { toast } from "utils/toast";
import { logError } from "shared/services/ErrorReporting";
import { TermsModal } from "pages/Login/components/TermsModal";
import { useAuth, useSession } from "contexts/AuthContext";

export function TermsAcceptanceOverlay() {
  const { user } = useSession();
  const { updateUserSettings, signOut } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation(["general", "login"]);

  const hasAcceptedCurrentTerms =
    user.settings?.acceptedTermsVersion === TERMS_AND_CONDITIONS_VERSION;

  const handleAgree = useCallback(async () => {
    setIsSubmitting(true);
    try {
      await updateUserSettings({
        acceptedTermsVersion: TERMS_AND_CONDITIONS_VERSION,
      });
    } catch (error) {
      setIsSubmitting(false);
      logError(error);
      toast.error(t("errors.generic"));
    }
  }, [updateUserSettings, t]);

  const showModal = !hasAcceptedCurrentTerms && !isSubmitting;

  return (
    <TermsModal open={showModal} onAgree={handleAgree} onCancel={signOut} />
  );
}
